import lang from '@data/lang.json'
import utils from '@/utils/utils'
import { mapState, mapActions } from 'vuex'


const ProductSort = {
  data () {
    return {
      lang: lang.ProductSort,
      options: [
        { id: 0, value: null, name: lang.ProductSort.ChooseSorting },
        { id: 1, value: 'PriceAsc', name: lang.ProductSort.PriceAsc },
        { id: 2, value: 'PriceDesc', name: lang.ProductSort.PriceDesc},
        { id: 3, value: 'AlphabeticallyAsc', name: lang.ProductSort.AlphabeticallyAsc},
        { id: 4, value: 'AlphabeticallyDesc', name: lang.ProductSort.AlphabeticallyDesc},
      ],
      selectedOption: this.getData('sortBy'),
    }
  },
  // Computed
  computed: {
    ...mapState({
      sortBy: state => state.filters.sortBy,
    }),
  },
  // Methods
  methods: {
    getData: function(key) {
      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      // Get data from search string else set it to default Choose Sorting
      const data = (!queryStringParams.get(key) || queryStringParams.get(key).length < 1)
        ? null
        : queryStringParams.get(key)

      const payload = {
        type: 'sortBy',
        value: data
      }
      // Update store
      this.$store.dispatch('filters/setFilter', payload)

      // Update state
      return data
    },
    setData: function() {
      const payload = [{
        type: 'sortBy',
        value: this.selectedOption
      },{
        type: 'pageIndex',
        value: 1
      }]
      // Update store
      this.$store.dispatch('filters/setFilter', payload)

      // Update query string
      this.updateQueryString(payload)

    },
    updateQueryString: function(payload) {
      bus.$emit('query_string_update')

      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      for (let index = 0; index < payload.length; index++) {
        const item = payload[index];
        if (!item.value) {
          queryStringParams.delete(item.type)
        } else {
          queryStringParams.set(item.type, item.value)
        }
      }

      const newURL = window.location.origin + window.location.pathname + '?' + queryStringParams.toString()
      window.history.pushState({path:newURL},'',newURL)
    },
  },
  // Life cycle
  created () {
    this.productType = this.options[0].value
  },

}

export default ProductSort
